import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseColor } from '@prophecy/theme';
import { Tooltip } from '../../Tooltip';
import { InnerLayer, StyledFeaturedIcon } from './styled';
import { IconSize, Variant } from './types';
export const FeaturedIcon = ({ variant = Variant.lightGradient, icon, size = IconSize.m, tooltip, hideTooltip, tone = BaseColor.primary }) => {
    return (_jsx(Tooltip, { title: tooltip, disabled: !!hideTooltip, children: _jsxs(StyledFeaturedIcon, { "$variant": variant, "$size": size, "$tone": tone, children: [_jsx(InnerLayer, { "$size": size, "$variant": variant, "$tone": tone }), icon] }) }));
};
